export default __webpack_public_path__ + "static/media/Interactive Map.231c0f0f.svg";